<template>
  <div
    @click="() => navigate(get(item, 'url', null))"
    :class="'main ' + (get(item, 'isRead') === false ? 'unread' : '')"
  >
    <div class="dot"></div>
    <div class="content">
      <h5>{{ get(item, 'title', '') }}</h5>
      <div class="description">{{ get(item, 'content', '') }}</div>
      <div class="time">{{ timeFromNow(get(item, 'createdAt')) }}</div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  props: {
    item: Object,
    default: () => {}
  },

  data() {
    return {
      get
    }
  },
  methods: {
    ...mapActions({
      update: 'postStaff/update',
      fetch: 'postStaff/fetch',
      countNotRead: 'postStaff/countNotRead'
    }),
    async navigate(url) {
      if (!url) return
      this.$router.push(url)
      await this.update({ id: this.item._id, isRead: true })
      this.fetch({ _start: 0, _limit: 10, receiver: this.$auth.user.id })
      this.countNotRead({ receiver: this.$auth.user.id })
    },

    timeFromNow(isoString = '') {
      if (!isoString) return
      // Kiểm tra chuỗi ngày hợp lệ
      if (!moment(isoString, moment.ISO_8601, true).isValid()) {
        throw new Error('Invalid ISO String')
      }

      // Sử dụng moment để tính thời gian từ bây giờ
      return moment(isoString).fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
.unread {
  background: #d3e4ff80;
}
.main {
  display: flex;
  padding-top: 5px;
  padding-bottom: 5px;
  min-height: 50px;
  border-bottom: 1px solid #e0e0e0;
}
.main:hover {
  background: #eff5ff80;
  cursor: pointer;
}
.dot {
  min-width: 8px;
  height: 8px;
  margin-top: 5px;
  margin-left: 15px;
  background-color: #0d47a1;
  border-radius: 50%;
}
.content {
  margin-left: 10px;
}
.title {
  font-weight: bold;
  font-size: 14px;
}
.description {
  font-size: 12px;
}
.time {
  font-size: 10px;
  color: #797979;
}
</style>
